import actions from './actions';
import mutations from './mutations';    
import state from './state';

export const spgc = {
  namespaced: true,
  state,
  actions,
  mutations,
};